import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
const SvgLucideSmartphone = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
    >
      <rect width={14} height={20} x={5} y={2} rx={2} ry={2} />
      <path d="M12 18h.01" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgLucideSmartphone);
const Memo = memo(ForwardRef);
export default Memo;
